export default "__VITE_ASSET__D0Rh8gbk__"